// 角色枚举
export default {
    VISITOR: '01',
    STAFF_MEMBER: '02'
}
